import { IDynamicFormValue } from "@/App/models/IDynamicFormValue";

/**
 * Builds data array from data object.
 * Empty values are excluded.
 *
 * @returns Array<IDynamicFormValue>
 */
export function buildDataFromObject(dataObject: any): Array<IDynamicFormValue> {
  return Object.keys(dataObject)
    .map((key: string) => ({ key, value: dataObject[key] }))
    .filter(({ value }) => value !== "");
}

/**
 * Maps data array to data object.
 *
 * @param data Array
 * @returns Object
 */
export function mapDataToObject(data: Array<IDynamicFormValue>): { [key: string]: any } {
  if (!Array.isArray(data)) {
    return {};
  }
  // From [{ key, value }] to { key: value }
  return [...data].reduce((accumulator, current) => {
    return { ...accumulator, [current.key]: current.value };
  }, {});
}
